import React, { useEffect, useRef } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { useIoContext } from '../context';

const IntersectionObserverView = (props) => {
  const { children, scope, extraData, intersectionObserver, ...args } = props;
  const targetRef = useRef(null);
  const ioctx = useIoContext();
  const io = intersectionObserver || ioctx?.intersectionObserver;

  useEffect(() => {
    // if (io.targets) {
    //   io.targets[scope] = {
    //     targetRef, // targetRef.current 可能拿不到，所以传targetRef
    //     scope,
    //     traceData,
    //   };
    // }

    io && io.observe(scope, targetRef, extraData);
    return () => {
      io && io.unobserve(scope);
      // if (io?.targets) {
      //   delete io.targets[scope];
      // }
    };
  }, []);

  return (
    <View ref={targetRef} collapsable={false}>
      {children}
    </View>
  );
};

IntersectionObserverView.prototype = {
  children: PropTypes.node, // 该组件中包的dom, 将原封不动展示
  scope: PropTypes.string, // 要监听组件的唯一标识， 页面级的
  extraData: PropTypes.object, // 其他额外的参数，可以是埋点上报的信息，要监听组件的数据源等

  intersectionObserver: PropTypes.object, // 工具类IntersectionObserver的对象
};

export default IntersectionObserverView;
